import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AuthService } from '../../../core/services/auth.service';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';

/**
 * LayoutComponent - Main application layout
 *
 * Shows topbar with authentication state:
 * - Not authenticated: Login button that opens dialog
 * - Authenticated: User menu with logout option
 * - No sidebar navigation (simplified to match readonly license app)
 */
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatDialogModule
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {
  private authService = inject(AuthService);
  private dialog = inject(MatDialog);

  readonly isAuthenticated = this.authService.isAuthenticated;
  readonly userEmail = this.authService.userEmail;

  /**
   * Open login dialog
   */
  openLoginDialog() {
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: false,
      autoFocus: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        console.log('✅ [Layout] User logged in:', result.user.email);
        // Auth state will update automatically via AuthService
      }
    });
  }

  /**
   * Logout current user
   */
  async logout() {
    try {
      await this.authService.logout();
      // Don't navigate anywhere - user stays on plans page
    } catch (error) {
      console.error('❌ [Layout] Logout error:', error);
    }
  }
}
